<template>
  <v-card>
    <v-card-title>
      <h1>{{ $t('Nueva conversación') }}</h1>
    </v-card-title>
    <v-card-text class="py-0">
      <v-checkbox
        v-model="newThreadData.send_my_customers"
        :label="myCustomersLabel"
        :disabled="myCustomers.length === 0"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-if="userIsSuperAdmin"
        v-model="newThreadData.send_all_customers"
        label="Seleccionar todos los clientes de la plataforma"
      ></v-checkbox>
      <og-user-select
        v-if="!bulkSend && users.length > 0"
        ref="userSelector"
        :users="users"
        :key="'receivers-' + bulkSend"
        v-model="newThreadData.user_id"
        :multiple="true"
        label="Enviar a los siguientes clientes"
      ></og-user-select>
      <og-user-select
        v-if="sendMyCustomers && myCustomers.length > 0"
        ref="myCustomersExclusionsSelector"
        :users="myCustomers"
        :key="'my-exclusions-' + sendMyCustomers"
        v-model="newThreadData.exclusion_user_ids"
        label="Excluir a los siguientes clientes"
        :multiple="true"
      ></og-user-select>
      <og-user-select
        v-if="userIsSuperAdmin && sendAllCustomers && users.length > 0"
        ref="userExclusionsSelector"
        :users="users"
        :key="'all-exclusions-' + sendAllCustomers"
        v-model="newThreadData.exclusion_user_ids"
        label="Excluir a los siguientes clientes"
        :multiple="true"
      ></og-user-select>

      <template v-if="!bulkSend">
        <v-select
          v-model="selectedClavedats"
          :items="formattedCompaniesOptions"
          item-text="text"
          item-value="value"
          solo
          chips
          multiple
          label="Asociar mensajes a empresas"
        ></v-select>
        <v-alert :value="true" type="info" class="black--text">
          El campo de arriba sirve para que se le asocie a cada conversación una empresa del
          usuario. Solo una empresa puede ser asociada por conversación. el campo tiene el formato
          "Nombre del usuario => Empresa".
        </v-alert>
      </template>
      <v-alert v-else :value="true" type="info" class="black--text">
        Se creará una conversación con cada cliente. Si el cliente solo tiene una empresa, la
        conversación se asocia a ella.
      </v-alert>
      <v-text-field solo v-model="newThreadData.title" label="Título del mensaje"></v-text-field>
      <custom-editor
        this.content
        v-model="newThreadData.message"
        advanced
        @input="updateMessage"
      ></custom-editor>
      <!-- <aru-wysiwyg-editor v-model="newThreadData.message"></aru-wysiwyg-editor> -->

      <!-- <v-textarea
        v-model="newThreadData.message"
        name="message"
        label="Mensaje"
        value="Hola. Estaba interesado en concertar una cita con ustedes."
      ></v-textarea> -->
      <v-autocomplete
        v-model="newThreadData.categories"
        :items="['Fiscal', 'Laboral', 'Contable', 'LOPD', 'Otros']"
        label="Categoría"
        chips
        solo
      ></v-autocomplete>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" @click.native="$emit('closeForm')">
        Cerrar
      </v-btn>
      <v-btn
        color="primary"
        :disabled="isSending || (!bulkSend && receivers.length === 0)"
        @click="bulkSend ? (showConfirmCreateNewThreadModal = true) : newThread()"
      >
        <v-progress-circular v-if="isSending" indeterminate color="primary"></v-progress-circular>
        Enviar
      </v-btn>
    </v-card-actions>
    <!-- Modal to delete bulk contacts -->
    <v-layout row justify-center>
      <v-dialog v-model="showConfirmCreateNewThreadModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Nueva conversación') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>¿Seguro que quieres enviar este mensaje a {{ bulkRecipientsText }}?</h2>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showConfirmCreateNewThreadModal = false">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="newThread()">
              {{ $t('Enviar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
  </v-card>
</template>

<script>
import ThreadAPI from '@/modules/myconsultant/services/thread.js';
import OgUserSelect from '@/components/commons/form/inputs/OgUserSelect.vue';
import CustomEditor from '@/components/commons/form/inputs/CustomEditor.vue';
import ProfileAPI from '@/services/api/profile.js';

export default {
  components: {
    OgUserSelect,
    CustomEditor,
  },
  props: ['customers'],
  data() {
    return {
      newThreadData: {
        user_id: this.customers ? this.customers : '',
        title: '',
        message: '',
        categories: [],
        exclusion_user_ids: [],
        send_all_customers: false,
        send_my_customers: false,
      },
      selectedClavedats: [],
      companiesOptions: [],
      threadForm: false,
      users: [],
      // Clientes activos del asesor: destinatarios de "Enviar a todos mis clientes"
      myCustomers: [],
      isSending: false,
      showConfirmCreateNewThreadModal: false,
    };
  },
  mounted() {
    ProfileAPI.getSelectActiveCustomerProfiles().then(res => {
      this.users = res.data.data;
    });
    ThreadAPI.getMyCustomerRecipients().then(res => {
      this.myCustomers = res.data.data;
    });

    if (localStorage.getItem('user')) {
      let user = JSON.parse(localStorage.getItem('user'));
      let categories = user.categories;
      this.newThreadData.categories = categories[0];
    }
    this.newThreadData.user_id = this.customers;
  },
  computed: {
    receivers() {
      return this.newThreadData.user_id || [];
    },
    userIsSuperAdmin() {
      const userRoleNames = this.$store.getters.userRoleNames;
      return userRoleNames.includes('superadmin');
    },
    sendAllCustomers() {
      return this.newThreadData.send_all_customers;
    },
    sendMyCustomers() {
      return this.newThreadData.send_my_customers;
    },
    bulkSend() {
      return this.sendAllCustomers || this.sendMyCustomers;
    },
    myCustomersLabel() {
      return `Enviar a todos mis clientes (${this.myCustomers.length})`;
    },
    bulkRecipientsText() {
      if (this.sendAllCustomers) {
        return 'todos los usuarios activos de la plataforma';
      }
      const excluded = this.newThreadData.exclusion_user_ids || [];
      const total = this.myCustomers.filter(customer => !excluded.includes(customer.id)).length;
      return total === 1 ? '1 cliente' : `${total} clientes`;
    },
    formattedCompaniesOptions() {
      return this.companiesOptions.map(company => {
        const isDisabled = !!this.selectedClavedats.find(comp => {
          return comp.user_id === company.user_id && comp.clavedat !== company.clavedat;
        });
        return {
          text: `${company.user_name} => ${company.company_name}`,
          value: { clavedat: company.clavedat, user_id: company.user_id },
          disabled: isDisabled,
        };
      });
    },
  },
  methods: {
    setInitialClavedats() {
      this.selectedClavedats = [];
      const userIds = [];
      this.companiesOptions.forEach(company => {
        if (!userIds.includes(company.user_id)) {
          userIds.push(company.user_id);
          this.selectedClavedats.push({
            clavedat: company.clavedat,
            user_id: company.user_id,
          });
        }
      });
    },
    newThread() {
      this.showConfirmCreateNewThreadModal = false;
      this.isSending = true;
      const data = {
        ...this.newThreadData,
        selected_clavedats: this.bulkSend ? [] : this.selectedClavedats,
      };
      ThreadAPI.postThread(data)
        .then(response => {
          this.isSending = false;
          this.resetNewThreadData();
          this.$emit('created', response.data);
        })
        .catch(() => {
          this.isSending = false;
        });
    },
    resetNewThreadData() {
      const customers = this.customers || [];
      if (!customers.length && this.$refs.userSelector) {
        this.$refs.userSelector.selected = [];
      }
      this.newThreadData = {
        user_id: customers.length ? customers : [],
        title: '',
        message: '',
        exclusion_user_ids: [],
        send_all_customers: false,
        send_my_customers: false,
      };
      if (localStorage.getItem('user')) {
        let user = JSON.parse(localStorage.getItem('user'));
        let categories = user.consultant_profile.categories;
        this.newThreadData.categories = categories[0].name;
      }
      this.selectedClavedats = [];
      this.companiesOptions = [];
    },
    updateMessage(value) {
      this.newThreadData.message = value;
    },
  },
  watch: {
    receivers: {
      deep: true,
      handler(val) {
        if (val.length) {
          ProfileAPI.getCompaniesOfUsers(this.receivers).then(res => {
            // Si mientras tanto se han quitado los destinatarios, la respuesta ya no vale
            if (!this.receivers.length) {
              return;
            }
            this.companiesOptions = res.data.data;
            this.setInitialClavedats();
          });
        } else {
          // Sin destinatarios no quedan empresas que asociar
          this.companiesOptions = [];
          this.selectedClavedats = [];
        }
      },
    },
    // Los dos envíos masivos son excluyentes y sustituyen a la selección manual
    sendAllCustomers(val) {
      if (val) {
        this.newThreadData.send_my_customers = false;
      }
      this.newThreadData.user_id = [];
      this.newThreadData.exclusion_user_ids = [];
    },
    sendMyCustomers(val) {
      if (val) {
        this.newThreadData.send_all_customers = false;
      }
      this.newThreadData.user_id = [];
      this.newThreadData.exclusion_user_ids = [];
    },
    customers(val) {
      this.newThreadData.user_id = val;
      if (this.$refs.userSelector) {
        this.$refs.userSelector.selected = val;
      }
    },
  },
};
</script>
